import api from './api';

class DashboardService {
  /**
   * Get dashboard summary statistics
   * @returns {Promise} API response with dashboard data
   */
  async getDashboardSummary() {
    try {
      const response = await api.get('/admin/dashboard');
      return response.data;
    } catch (error) {
      // Error will be handled by API interceptor and notification will be shown
      throw error;
    }
  }
}

const dashboardService = new DashboardService();
export default dashboardService;